import { makeStyles } from "@fluentui/react-components";

export const useClauseDocumentInfoStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyItems: "center",
    alignItems: "flex-start",
    width: "100%",
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
  },
  fieldItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    columnGap: "5px",
    rowGap: "5px",
    flexWrap: "wrap",
    width: "100%",
  },
  truncateText: {
    display: "inline-block",
    maxWidth: "80vw",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  virtuosoContainer: {
    flex: 1,
    overflowY: "auto",
    width: "100%",
  },
  virtuoso: {
    margin: "0",
    width: "100%",
  },
});
